const SITE = 'https://tilkiotomasyon.com';
const ORG_ID = `${SITE}/#organization`;
// Satır içi **kalın** ve [metin](/yol) işaretlerini düz metne çevirir (şema metni için).
export const plainText = (text) => text.replace(/\*\*(.+?)\*\*/g, '$1').replace(/\[(.+?)\]\((.+?)\)/g, '$1');

// 2) FAQPage — sorular sayfadaki metinle birebir aynı olmalı.
//    Aynı soru birden fazla sayfanın FAQPage şemasına girmez.
export const faqPageJsonLd = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: plainText(f.a) },
  })),
});

// 3) BreadcrumbList — alt sayfalarda (items: [{ name, path }])
export const breadcrumb = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.path}`,
  })),
});

// 4) BlogPosting — blog yazısı sayfasında (/blog/:slug); post.image tam URL
export const articleJsonLd = (post) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: post.title,
  description: post.description,
  image: post.image,
  datePublished: post.date,
  dateModified: post.updated || post.date,
  inLanguage: 'tr-TR',
  ...(post.keywords?.length ? { keywords: post.keywords.join(', ') } : {}),
  mainEntityOfPage: `${SITE}/blog/${post.slug}`,
  author: { '@type': 'Organization', '@id': ORG_ID, name: 'Tilki Otomasyon', url: `${SITE}/` },
  publisher: {
    '@type': 'Organization',
    '@id': ORG_ID,
    name: 'Tilki Otomasyon',
    logo: { '@type': 'ImageObject', url: `${SITE}/web-app-manifest-512x512.png` },
  },
});

// 5) Blog — /blog listesi
export const blogJsonLd = (posts) => ({
  '@context': 'https://schema.org',
  '@type': 'Blog',
  '@id': `${SITE}/blog`,
  url: `${SITE}/blog`,
  name: 'Tilki Otomasyon Blog',
  inLanguage: 'tr-TR',
  publisher: { '@id': ORG_ID },
  blogPost: posts.map((p) => ({
    '@type': 'BlogPosting',
    headline: p.title,
    url: `${SITE}/blog/${p.slug}`,
    datePublished: p.date,
  })),
});
